import React, { useState, useRef } from "react";
import "./Transportation_of_building_materials.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";

export default function Transportation_of_industrial_and_heavy_generators() {
  return (
    <div className="Transportation_of_building_materials-page">

      <div className="Transportation_of_building_materials-hero">
        <div className="Transportation_of_building_materials-overlay">
          <h1>הובלת גנרטורים תעשייתיים כבדים</h1>
        </div>
      </div>

      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">

          {/* =====================================================
              VIDEO - ראשון
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              הובלת גנרטורים תעשייתיים כבדים
            </div>

            <div className="building-video-wrapper">

              <video
                className="building-video"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                playsInline
                preload="metadata"
                onContextMenu={(e) => e.preventDefault()}
              >
                <source
                  src="/video/18.mp4"
                  type="video/mp4"
                />

                הדפדפן שלך אינו תומך בניגון וידאו.
              </video>

            </div>

            <p className="building-video-caption">
              צפו בסרטון והכירו את שירותי הובלת הגנרטורים התעשייתיים הכבדים של נצר הובלות ומנופים
            </p>

          </div>


          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">
            הובלת גנרטורים תעשייתיים כבדים דורשת תכנון נכון, ציוד
            מתאים וניסיון בעבודה עם מטענים גדולים וכבדים. נצר הובלות
            ומנופים מספקת שירותי הובלת גנרטורים לקבלנים, חברות,
            מפעלים, אתרי בנייה, עסקים ולקוחות פרטיים, בהתאם לסוג
            הגנרטור, למשקל ולתנאי השטח.
          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">
              <img
                src="/images/35.jpeg"
                alt="הובלת גנרטורים תעשייתיים כבדים"
              />
            </div>

            <div className="text-box">

              <p>
                הובלת גנרטור תעשייתי כבד דורשת התאמה בין סוג
                הגנרטור, משקלו, מידותיו ותנאי הגישה במקום האיסוף
                והפריקה. לפני ביצוע ההובלה חשוב לבחון את משקל
                הגנרטור, מידותיו, אופן ההעמסה והפריקה והאפשרות
                להגיע בבטחה לנקודת היעד.
              </p>

              <p>
                נצר הובלות ומנופים מספקת פתרונות להובלת גנרטורים
                תעשייתיים, גנרטורים לאתרי בנייה, גנרטורים למפעלים,
                מערכות גיבוי חשמל וציוד כבד נוסף, בהתאם לסוג
                ההובלה ולתנאים בשטח.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            הובלת גנרטורים תעשייתיים כבדים – תכנון נכון לפני תחילת העבודה
          </h2>

          <div className="bottom-text">

            <p>
              כל הובלת גנרטור תעשייתי מתחילה בבדיקת פרטי ההובלה.
              יש להבין מהו סוג הגנרטור, מה המשקל הכולל, מהן
              מידותיו ומהי נקודת האיסוף והפריקה.
            </p>

            <p>
              בנוסף יש לבחון את תנאי הדרך ואת הגישה לאתר, לרבות
              רחובות צרים, חניות, שערים, אתרי בנייה, מפעלים,
              אזורי תעשייה, כניסות מורכבות ומגבלות אחרות שעלולות
              להשפיע על ביצוע ההובלה.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              הובלת גנרטורים באמצעות משאית
            </h2>

            <p>
              משאית מתאימה מאפשרת להעביר גנרטורים תעשייתיים
              מאתר אחד לאחר בצורה מסודרת. התאמת המשאית נעשית
              בהתאם לסוג הגנרטור, למשקל, למידות ולתנאי הגישה.
            </p>

            <p>
              במקרים שבהם יש צורך גם בהעמסה או בפריקה באמצעות
              מנוף, ניתן לשלב פתרון הכולל הובלה ומנוף בהתאם
              לדרישות העבודה ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              הובלת גנרטורים למפעלים ולאתרי בנייה
            </h2>

            <p>
              באתרי בנייה, מפעלים, מרכזים מסחריים ועסקים יש לעיתים
              צורך בהובלת גנרטורים כבדים לצורך אספקת חשמל, גיבוי
              מערכות או הפעלה של ציוד ומתקנים שונים.
            </p>

            <p>
              נצר הובלות ומנופים מספקת שירותי הובלת גנרטורים
              למפעלים, אתרי בנייה, עסקים ולמגוון נקודות ברחבי
              הארץ, בהתאם לצורכי הלקוח ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              הובלת גנרטורים עם מנוף
            </h2>

            <p>
              במקרים שבהם נקודת הפריקה אינה נגישה ישירות למשאית,
              ניתן להשתמש במנוף לצורך הרמת הגנרטור והעברתו אל
              נקודת הפריקה או ההצבה המתאימה, בהתאם לאפשרויות
              העבודה בשטח.
            </p>

            <p>
              שילוב של הובלה ומנוף יכול לסייע במקרים שבהם נדרשת
              הרמה של גנרטור אל שטח מוגבה, חצר, אתר בנייה, אזור
              תעשייה או מקום שבו הגישה מורכבת.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              הובלת גנרטורים כבדים והצבתם במקום חדש
            </h2>

            <p>
              גנרטורים תעשייתיים מגיעים במגוון גדלים, משקלים
              ותצורות. לפני ביצוע העבודה יש לבדוק את משקל הגנרטור,
              מידותיו, אופן ההעמסה והפריקה ואת נקודת ההצבה.
            </p>

            <p>
              בהתאם לסוג העבודה ניתן לתכנן את ההובלה כך שתתאים
              למשקל הגנרטור, למידותיו ולתנאי הגישה באתר.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור חברה מקצועית להובלת גנרטורים?
            </h2>

            <p>
              הובלת גנרטורים תעשייתיים כבדים דורשת תכנון נכון,
              היכרות עם מטענים כבדים והתאמת אמצעי ההובלה למשימה.
              בדיקה מוקדמת של תנאי השטח יכולה לסייע בתכנון
              יעיל של ההובלה והפריקה.
            </p>

            <p>
              נצר הובלות ומנופים מתאימה את פתרון ההובלה לסוג
              הגנרטור, למשקל המטען, למידותיו, לתנאי הדרך ולדרישות
              הפרויקט.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              נצר הובלות ומנופים – הובלת גנרטורים תעשייתיים בפריסה ארצית
            </h2>

            <p>
              נצר הובלות ומנופים בע"מ מספקת שירותי הובלת גנרטורים
              תעשייתיים כבדים, מערכות גיבוי חשמל וציוד כבד למפעלים,
              אתרי בנייה, עסקים ולקוחות פרטיים. השירות ניתן בהתאם
              לסוג הגנרטור, למשקל ולתנאים הקיימים בשטח.
            </p>

            <p>
              צריכים הובלת גנרטור תעשייתי כבד? צרו איתנו קשר,
              ספרו לנו מה משקל הגנרטור, מה המידות שלו והיכן נדרשת
              ההובלה, ונבחן עבורכם את פתרון ההובלה המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Transportation_and_lifting_of_glass_in_a_vacuum"
              className="link-right"
            >
הובלה והרמה של זכוכית בוואקום
            </Link>

            <Link
              to="/Transportation_of_building_materials"
              className="link-left"
            >
הובלת חומרי בניין
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}
